export default __webpack_public_path__ + "static/blob9-be0dfec5b921b3683f520aba2084dd55.svg";